<div
  class="floating-container"
  #floatingContainer
  [ngClass]="{ 'floating-container--dragging': isDragging }"
>
  <ng-content></ng-content>
  @for (portal of selectedPortals(); track $index) {
    <ng-template [cdkPortalOutlet]="portal"></ng-template>
  }
  <dw-ui-floating-button
    class="dragdrop__button"
    [ngClass]="{ 'dragdrop__button--dragging': isDragging }"
    #dragdropButton
    (mousedown)="isDragging = true"
    trigger
    [backgroundColor]="'var(--bs-secondary)'"
    [icon]="'digi-out-dragdrop'"
    [label]="'Error'"
  >
  </dw-ui-floating-button>
</div>
